import { Injectable }       from '@angular/core';
import { NgbModal }         from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';

import { ApiService }               from '../api/api.service';
import { CompanyIntegrationsModel } from '../companies/models/company.integrations';
import { ConfirmService }           from '../messages/confirm/confirm.service';
import { PodiumKeysModel }          from './typings/podium.keys';
import { PodiumSettingsModel }      from './typings/podium.settings.model';
import { SecretKeysComponent }      from '../shared/components/secret-keys/secret-keys.component';

@Injectable({
  providedIn: 'root'
})
export class PodiumService {
  public title = this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.PODIUM');

  constructor (
    private apiService      : ApiService,
    private confirmService  : ConfirmService,
    private modalService    : NgbModal,
    private translateService: TranslateService
  ) {}

  activate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.INTEGRATIONS.ACTIVATE', {
        name: this.title
      }))
      .then(() => this.apiService.get('/company_integrations/enable_podium_api'));
  }

  deactivate () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('JS_SPACE.CONFIRM.REMOVE_INTEGRATION', {
        name: this.title
      }))
      .then(() => this.apiService.get('/company_integrations/disable_podium_api'));
  }

  generateApiKey () : Promise<any> {
    return this.confirmService.generic(this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.GENERATE_NEW_KEY'), '', {
        cancelText : this.translateService.instant('GENERAL_SPACE.BUTTON.CANCEL'),
        confirmText: this.translateService.instant('COMPANY_SPACE.INTEGRATIONS.WS_API.GENERATE')
      })
      .then(() => this.apiService.get('/company_integrations/generate_podium_api_key'))
      .then(( keys : PodiumKeysModel ) => {
        const modal =  this.modalService.open(SecretKeysComponent, {
          size: 'lg'
        });

        modal.componentInstance.keys = {
            apiKey   : keys.podium_api_key,
            companyId: keys.company_id,
            secretKey: keys.podium_api_secret
          };

        return modal.result;
      });
  }

  getIntegrations () : Promise<CompanyIntegrationsModel> {
    return this.apiService.get('/company_integrations');
  }

  getSettings () : Promise<PodiumSettingsModel> {
    return this.apiService.get('/company_integrations/get_podium_api_details');
  }
}
